import React, { useState } from 'react'
import { Button, Row, Col, Icon, Grid, Message } from 'rsuite'
import CoiApproveProjectWidget from './CoiApproveProjectWidget'
import COIValidateTableWidget from './COIValidateTableWidget'
import { verifyConfilictOfInterests } from '../../redux/actions/conflictOfInterests'
import { doneLoading, startLoading } from '../../utils/loading'
import { sessionGetItemStr } from '../../utils/sessionHelpers'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import SaveButton from '../../components/buttons/saveButton/SaveButton'

export default function COIValidateWidget({
  disabled,
  hideCheckCOI = false,
  isCOIPass,
  setIsCOIPass = () => {},
  checkCOI,
  setCheckCOI = () => {},
  setIsCheckCOI = () => {},
  checkInterest,
  setCheckInterest = () => {},
  fixType,
  getValues,
  isBold,
  ...props
}) {
  const [isCompleted, setIsCompleted] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isValid, setIsValid] = useState(isCOIPass)
  const [dataTable, setDataTable] = useState([])
  const [msgError, setMsgError] = useState()

  const projectId = sessionGetItemStr('projectId')

  const handleVerifyConfilictOfInterests = async () => {
    try {
      setIsCompleted(false)
      setDataTable([])
      setIsValid(false)
      setMsgError('')

      const req = await genRequestBody(fixType)
      const res = await callVerifyCoi(req)
      // console.log('ress => ', res)

      if (res?.length > 0) {
        setDataTable(res)

        const isPass = !res.find((e) => e.result === true)

        setIsValid(isPass)
        setIsCOIPass(isPass)
        setIsCompleted(true)
        setIsCheckCOI(true)
      } else {
        setDataTable([])
      }
    } catch (error) {
      console.error('error => ', error)
    }
  }

  const genRequestBody = async (_type) => {
    // console.log('type => ', _type)
    let request = {}
    let newArr = []

    switch (_type) {
      case '1':
      case '2':
      case '6':
      case '7':
      case '8':
      case '9':
      case '10':
        request = {
          projectVersionId: projectId,
          type: _type,
          listId: null,
        }
        break

      case '3':
        let coordinator = getValues('coordinator')

        if (!coordinator) {
          setMsgError('กรุณาเลือก "ผู้ประสานงาน" ก่อนตรวจสอบ COI')
          return false
        }

        newArr.push(coordinator)

        request = {
          projectVersionId: projectId,
          type: '3',
          listId: newArr,
        }
        break

      case '5':
        let expert = sessionGetItemStr('selectedExpert')
        // console.log('ex => ', JSON.parse(expert))

        if (expert) {
          let arrExpert = JSON.parse(expert)

          arrExpert.map((item) => {
            // console.log('item => ', item)
            newArr.push(item.id)
          })
        } else {
          setMsgError('กรุณาเลือก "ผู้ทรงคุณวุฒิ" ก่อนตรวจสอบ COI')
          return false
        }

        request = {
          projectVersionId: projectId,
          type: _type,
          listId: newArr,
        }
        break

      default:
        break
    }

    return request
  }

  const callVerifyCoi = async (request) => {
    startLoading()
    setIsLoading(true)
    try {
      const _schema = await verifyConfilictOfInterests(request)
      setIsLoading(false)
      doneLoading()

      if (_schema?.model?.dataTable?.length == 0) {
        setMsgError(_schema.message)
      }

      return _schema.model.dataTable
    } catch (e) {
      console.error('error => ', e)
    }
    setIsLoading(false)
    doneLoading()
  }

  return (
    <>
      {isLoading && <OverlayLoader />}

      <Grid fluid>
        {!hideCheckCOI && (
          <>
            <Row style={{ marginBottom: 10 }}>
              <CoiApproveProjectWidget
                check={checkCOI}
                onCheck={(check) => setCheckCOI(check)}
                disabled={disabled || isLoading}
                checkInterest={checkInterest}
                onCheckInterest={(check) => setCheckInterest(check)}
                fixType={fixType}
                isBold={isBold}
              />
            </Row>
          </>
        )}
        <Row style={{ marginBottom: 10 }}>
          <Col>
            <span style={{ fontWeight: isBold ? 'bold' : undefined }}>
              {`${
                fixType == '10' || fixType == '5' ? '1.' : '2.'
              }  ${'ตรวจสอบการมีส่วนได้ส่วนเสียโดยระบบ (COI) :'}`}
            </span>

            {isCompleted && isValid && (
              <>
                <Icon
                  size="lg"
                  style={{ marginLeft: 10, color: '#21a383' }}
                  icon={'check-circle'}
                />{' '}
                ผ่าน
              </>
            )}
            {isCompleted && !isValid && (
              <>
                <Icon
                  size="lg"
                  style={{ marginLeft: 10, color: '#eb3626' }}
                  icon={'close-circle'}
                />{' '}
                ไม่ผ่าน
              </>
            )}
            <SaveButton
              style={{ marginLeft: 10 }}
              disabled={disabled || isLoading}
              onClick={() => {
                handleVerifyConfilictOfInterests()
              }}
              icon="search"
              children="ตรวจสอบ COI"
            />
            {/* <Button
              style={{ marginLeft: 10 }}
              appearance="primary"
              disabled={disabled || isLoading}
              onClick={() => {
                handleVerifyConfilictOfInterests()
              }}
            >
              ตรวจสอบ COI
            </Button> */}
          </Col>
        </Row>

        {msgError && (
          <Row style={{ marginBottom: 10 }}>
            <Message showIcon type="error" description={msgError} style={{ marginBottom: 10 }} />
          </Row>
        )}

        <Row style={{ marginBottom: 10 }}>
          <COIValidateTableWidget tableData={dataTable} />
        </Row>
      </Grid>
    </>
  )
}
